import { render, staticRenderFns } from "./NoMortgageDataAlternativesPage.vue?vue&type=template&id=b8ee0338&scoped=true"
import script from "./NoMortgageDataAlternativesPage.vue?vue&type=script&lang=js"
export * from "./NoMortgageDataAlternativesPage.vue?vue&type=script&lang=js"
import style0 from "./NoMortgageDataAlternativesPage.vue?vue&type=style&index=0&id=b8ee0338&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8ee0338",
  null
  
)

export default component.exports